<ng-container *portal>
  <div class="print-container">
    <div class="print">
      <span id="print.title" class="print__title">{{title}}</span>
      <span id="print.date" class="print__date">{{dateCreated}}</span>
      @for (printSection of printSections; track printSection) {
        <div class="print-section">
          @if (printSection.sectionName) {
            <span class="print-section__title">{{printSection.sectionName}}</span>
          }
          @for (item of printSection.labeledValues; track item) {
            <div class="print-section__item">
              <span class="print-section__label">{{item.label}}</span>
              <span class="print-section__value">{{item.value}}</span>
            </div>
          }
          @if (printSection.tableData.length > 0) {
            <table class="print-table">
              <tbody>
                <tr>
                  @for (columnHeader of objectKeys(printSection.tableData[0]); track columnHeader) {
                    <th class="print-table__header">
                      {{formatUtils.titleCase(columnHeader)}}
                    </th>
                  }
                </tr>
                @for (data of printSection.tableData; track data) {
                  <tr>
                    @for (key of objectKeys(printSection.tableData[0]); track key) {
                      <td class="print-table__data">
                        {{data[key]}}
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      }
    </div>
    <div class="row row--end margin-top margin-top--lg hide-print">
      <button class="btn btn--primary" onclick="print()">Print</button>
    </div>
  </div>
</ng-container>
